// Live events: signals the backend pushes to open portal tabs over GET api/events/stream
// (server-sent events) after a fact changed, so a view can refetch what the signal names.
// The stream carries nothing but these signals; the normal endpoints stay the source of truth.
// See docs/live-events.md.

export const LiveEventType = {
    /** An appointment the backend created, moved, edited or deleted in Outlook (ICalendarChangedEvent). */
    calendarChanged: 'calendar-changed',
    /** A lead came in or was opened for the first time (ILeadChangedEvent); feeds the new-leads badge. */
    leadChanged: 'lead-changed',
} as const;
export type LiveEventType = (typeof LiveEventType)[keyof typeof LiveEventType];

export interface ILiveEvent<T = unknown> {
    id: string;
    type: LiveEventType;
    data: T;
}

export type LeadChangeKind = 'created' | 'viewed';

export interface ILeadChangedEvent {
    kind: LeadChangeKind;
    client_id: number;
    planning_item_id: number | null;
}
